import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LiteralService } from 'src/app/services';
import { images } from 'src/images';

@Component({
    selector: 'app-service-routes-search-bar',
    templateUrl: './service-routes-search-bar.component.html',
    styleUrl: './service-routes-search-bar.component.scss',
    standalone: false
})
export class ServiceRoutesSearchBarComponent {

  @Input() placeholder = '';
  @Input() searching = false;
  @Output() searchEventEmitter = new EventEmitter<string>();

  public images = images;

  constructor(public literalService: LiteralService) {}

  search(event: any) {
    this.searchEventEmitter.emit(event);
  }

}
